"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.fetchRetry = void 0;
var sleep_1 = require("../util/sleep");
var logger_1 = require("../logger");
var timed_1 = require("../util/timed");
var grapheneMetrics_1 = require("../grapheneMetrics");
var omit_1 = __importDefault(require("lodash/omit"));
var random_1 = __importDefault(require("lodash/random"));
function fetchRetry(url, fetchArgs) {
    var _a;
    if (fetchArgs === void 0) { fetchArgs = {}; }
    return __awaiter(this, void 0, void 0, function () {
        var attempt, disableKeepalive, _loop_1, state_1;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    attempt = 1;
                    disableKeepalive = false;
                    _loop_1 = function () {
                        var args, timeoutId, controller_1, status_1, response, e_1, sleepMs;
                        return __generator(this, function (_c) {
                            switch (_c.label) {
                                case 0:
                                    args = typeof fetchArgs === "function" ? fetchArgs() : fetchArgs;
                                    if (disableKeepalive) {
                                        args.keepalive = false;
                                    }
                                    timeoutId = undefined;
                                    if (!args.signal) {
                                        controller_1 = new AbortController();
                                        timeoutId = setTimeout(function () { return controller_1.abort(); }, TIMEOUT_MS);
                                        args.signal = controller_1.signal;
                                    }
                                    status_1 = "";
                                    _c.label = 1;
                                case 1:
                                    _c.trys.push([1, 4, 5, 6]);
                                    return [4, (0, timed_1.timed)(function () { return fetch(url, (0, omit_1["default"])(args, ["onStatus"])); }, {
                                            metricsName: grapheneMetrics_1.NETWORK_REQUEST_LATENCY_MS
                                        })];
                                case 2:
                                    response = _c.sent();
                                    status_1 = response.status.toString();
                                    return [4, ((_a = args === null || args === void 0 ? void 0 : args.onStatus) === null || _a === void 0 ? void 0 : _a.call(args, response.status))];
                                case 3:
                                    _c.sent();
                                    if (response.ok) {
                                        grapheneMetrics_1.blizzardGraphene.addHistogram({
                                            metricsName: grapheneMetrics_1.NETWORK_REQUEST_ATTEMPTS_COUNT,
                                            dimensions: urlToDimensions(url),
                                            value: attempt
                                        });
                                        return [2, { value: response }];
                                    }
                                    log.warn("Request failed", response.status, response.statusText);
                                    return [3, 6];
                                case 4:
                                    e_1 = _c.sent();
                                    log.warn("fetch error", e_1);
                                    status_1 = "error_".concat(e_1 instanceof Error ? e_1.name : typeof e_1);
                                    if (args.keepalive) {
                                        log.debug("Received an error while keepalive was enabled, retrying without keepalive", e_1);
                                        disableKeepalive = true;
                                    }
                                    return [3, 6];
                                case 5:
                                    if (timeoutId) {
                                        clearTimeout(timeoutId);
                                    }
                                    grapheneMetrics_1.blizzardGraphene.increment({
                                        metricsName: grapheneMetrics_1.NETWORK_REQUEST,
                                        dimensions: __assign(__assign({}, urlToDimensions(url)), { status: status_1 })
                                    });
                                    return [7];
                                case 6:
                                    if (!(attempt < MAX_ATTEMPTS)) return [3, 8];
                                    sleepMs = calculateBackoff(attempt);
                                    log.debug("Retrying after ".concat(sleepMs, "ms..."));
                                    return [4, (0, sleep_1.sleep)(sleepMs)];
                                case 7:
                                    _c.sent();
                                    _c.label = 8;
                                case 8: return [2];
                            }
                        });
                    };
                    _b.label = 1;
                case 1: return [5, _loop_1()];
                case 2:
                    state_1 = _b.sent();
                    if (typeof state_1 === "object")
                        return [2, state_1.value];
                    _b.label = 3;
                case 3:
                    if (attempt++ < MAX_ATTEMPTS) return [3, 1];
                    _b.label = 4;
                case 4: return [2, null];
            }
        });
    });
}
exports.fetchRetry = fetchRetry;
var log = (0, logger_1.getLogger)("fetchRetry");
var calculateBackoff = function (attempt) {
    return attempt === 1 ? 0 : (0, random_1["default"])(0, RETRY_DELAY_BASE_MS * Math.pow(2, attempt - 2));
};
function urlToDimensions(urlStr) {
    try {
        var url = new URL(urlStr);
        return {
            host: url.hostname.substring(0, 64),
            path: url.pathname.replace(/^\//, "").substring(0, 64)
        };
    }
    catch (e) {
        if (e instanceof TypeError) {
            return {
                host: "invalid",
                path: "invalid"
            };
        }
        throw e;
    }
}
var MAX_ATTEMPTS = 10;
var RETRY_DELAY_BASE_MS = 250;
var TIMEOUT_MS = 150 * 1000;
//# sourceMappingURL=fetchRetry.js.map